export default "__VITE_ASSET__334b8cf1__"